var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AppLayout from '@/Layouts/AppLayout';
import { usePage } from '@inertiajs/react';
import CreateTeamForm from "./Teams/CreateTeamForm";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
export default function Dashboard(_a) {
    var team = _a.team;
    var route = useRoute(Ziggy);
    var flash = usePage().props.flash;
    var _b = useState(true), open = _b[0], setOpen = _b[1];
    useEffect(function () {
        if (flash.new_credits) {
            setOpen(true);
        }
    });
    return (_jsx(AppLayout, __assign({ title: "Dashboard", pageTitle: "You have no team" }, { children: _jsx("div", { children: _jsx(CreateTeamForm, {}) }) })));
}
